module.exports = __webpack_public_path__ + "img/converse-details2.ec32f1a9.png";